<template>
  <a-row :gutter="20" class="dashboard">
    <a-col :span="isDesktop ? 16 : 24">
      <a-card :title="$t('cardTitle.updateChurchProfile')" class="style3" :loading="isLoadingInfo">
        <a-form :form="form" :label-col="isDesktop ? { span: 6 } : {}" :wrapper-col="isDesktop ? { span: 18 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
          <a-form-item :label="$t('label.counselingPastor')">
            <a-input
              v-decorator="[
                'care_pastor',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('placeholder.pleaseInputCarePastor'),
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item :label="$t('label.counselingContactEmail')">
            <a-input
              v-decorator="[
                'care_email',
                {
                  rules: [
                    {
                      type: 'email',
                      required: true,
                      message: $t('placeholder.pleaseInputCareEmail'),
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item :label="$t('label.churchAddress')">
            <a-input
              v-decorator="[
                'care_address',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('placeholder.pleaseInputCareAddress'),
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item :label="$t('label.churchPhone')">
            <a-input
              v-decorator="[
                'care_phone',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('placeholder.pleaseInputCarePhone'),
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item :label="$t('label.churchWebsite')">
            <a-input
              v-decorator="[
                'care_website',
                {
                  rules: [
                    {
                      required: false,
                      message: $t('placeholder.pleaseInputCareWebsite'),
                    },
                  ],
                },
              ]"
            />
          </a-form-item>

          <a-form-item :label="$t('label.welcomeVideoEmbedCode')">
            <a-textarea v-decorator="['care_video_embed']" :rows="4" />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 12, offset: 4 }">
            <a-button type="primary" html-type="submit" :loading="isLoading">{{ $t('button.updateProfile') }}</a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { mapState } from 'vuex';
import UserService from '@/services/UserService';
import { get, isEmpty } from 'lodash';
export default {
  data: () => ({
    isLoading: false,
    isLoadingInfo: true,
  }),
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'churchProfile' });
  },
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  async mounted() {
    const resp = await UserService.doGetChurchProfile();
    this.isLoadingInfo = false;
    if (!isEmpty(resp)) {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          care_pastor: resp.care_pastor,
          care_email: resp.care_email,
          care_address: resp.care_address,
          care_phone: resp.care_phone,
          care_website: resp.care_website,
          care_video_embed: resp.care_video_embed,
        });
      });
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            await UserService.doUpdateChurchProfile(values);
            this.$notification['success']({
              message: 'Update successful.',
              description: `Church profile was updated successfully.`,
            });
          } catch (error) {
            console.log(error);
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>
